<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
    <path
      d="M10.1996 0.599609H1.79961C1.13687 0.599609 0.599609 1.14682 0.599609 1.82183V13.0828C0.599609 13.9293 1.42408 14.5195 2.20607 14.2328L3.14313 13.8892C3.43594 13.7818 3.75824 13.7945 4.04203 13.9246L5.50717 14.5961C5.82034 14.7397 6.17888 14.7397 6.49205 14.5961L7.95719 13.9246C8.24098 13.7945 8.56328 13.7818 8.85609 13.8892L9.79315 14.2328C10.5751 14.5195 11.3996 13.9293 11.3996 13.0828V1.82183C11.3996 1.14682 10.8624 0.599609 10.1996 0.599609Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
    />
    <path
      d="M3.5498 4.5H5.99425M3.5498 6.94444H8.43869M3.5498 9.38889H8.43869"
      stroke="currentColor"
      stroke-width="1.05"
      stroke-linecap="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
